
<div class="select-container">
  <select [ngModel]="icon" (change)="iconChanged($event)">
    <option *ngFor="let iconClass of options" [value]="iconClass">{{ displayName(iconClass) }}</option>
  </select>
</div>
<div class="icon-preview-container" *ngIf="icon">
  <div class="component-icon" [ngClass]="getClasses()"></div>
</div>